import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach access token from localStorage if cookie is unavailable cross-site.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("factskoot_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatMoney(amount, currency = "INR") {
  if (amount == null) return "—";
  const map = { INR: "₹", USD: "$", SGD: "S$", GBP: "£", EUR: "€" };
  const sym = map[currency] || currency + " ";
  return `${sym}${Number(amount).toLocaleString("en-IN")}`;
}

// Resolve a user's landing route. Honours sub_role overrides (Wave R1).
export function homeForUser(user) {
  if (!user) return "/app/parent";
  if (user.role === "non_teaching_staff" && user.sub_role === "technical_coordinator") {
    return "/app/tech-coord";
  }
  return ROLE_HOME[user.role] || "/app/parent";
}

export const ROLE_HOME = {
  super_admin: "/app/admin",
  franchise_hq_admin: "/app/franchise-hq",
  hq_admin: "/app/franchise-hq",          // legacy alias
  branch_admin: "/app/branch",
  principal: "/app/branch",
  academic_coordinator: "/app/branch",
  medical_coordinator: "/app/medical-coord",
  counsellor: "/app/counsellor",
  teacher: "/app/teacher",
  activity_trainer: "/app/teacher",
  father: "/app/parent",
  mother: "/app/parent",
  guardian: "/app/parent",
  parent: "/app/parent",                  // legacy alias
  non_teaching_staff: "/app/staff",
  non_teaching: "/app/staff",             // legacy alias
  transport_staff: "/app/transport-staff",
  transport: "/app/transport-staff",      // legacy alias
  support_staff: "/app/support-staff",
  support: "/app/support-staff",          // legacy alias
  inventory_staff: "/app/inventory-staff",
  inventory: "/app/inventory-staff",      // legacy alias
  vendor: "/app/vendor-portal",
  auditor: "/app/auditor",
  student: "/app/parent",
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  franchise_hq_admin: "Franchise HQ",
  hq_admin: "Head Office",
  branch_admin: "Branch Admin",
  principal: "Principal",
  academic_coordinator: "Academic Coordinator",
  medical_coordinator: "Medical Coordinator",
  counsellor: "Counsellor",
  teacher: "Teacher",
  activity_trainer: "Activity Trainer",
  father: "Father",
  mother: "Mother",
  guardian: "Guardian",
  parent: "Parent",
  non_teaching_staff: "Non-Teaching Staff",
  non_teaching: "Non-Teaching Staff",
  transport_staff: "Transport",
  transport: "Transport",
  support_staff: "Support",
  support: "Support",
  inventory_staff: "Inventory",
  inventory: "Inventory",
  vendor: "Vendor Partner",
  auditor: "Auditor",
  student: "Student",
};

// Wave R1: subrole labels — drives badges next to the role name.
export const SUB_ROLE_LABEL = {
  technical_coordinator: "Technical Coordinator",
};
